const VideoModal = {
    modal: null,
    content: null,
    container: null,

    setup() {
        this.modal = document.getElementById('video-modal');
        this.content = document.querySelector('.video-modal-content');
        this.container = document.querySelector('.video-modal-container');

        if (!this.modal) return;

        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-video-modal]');
            if (trigger) {
                e.preventDefault();
                const url = trigger.dataset.videoUrl || trigger.getAttribute('href');
                if (url) this.open(url);
            }
        });

        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.close();
        });

        const closeBtn = document.querySelector('.video-modal-close');
        if (closeBtn) closeBtn.addEventListener('click', () => this.close());

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.close();
        });
    },

    open(url) {
        const { embed, isAudio } = this.buildEmbed(url);
        this.content.innerHTML = embed;
        this.modal.classList.add('is-active');
        this.container.classList.toggle('video-modal-container--audio', isAudio);
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    },

    close() {
        this.modal.classList.remove('is-active');
        this.modal.setAttribute('aria-hidden', 'true');
        this.content.innerHTML = '';
        document.body.style.overflow = '';
    },

    buildEmbed(url) {
        const youtubeId = this.getYoutubeId(url);
        if (youtubeId) {
            return {
                embed: `<iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`,
                isAudio: false,
            };
        }

        const vimeoId = this.getVimeoId(url);
        if (vimeoId) {
            return {
                embed: `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`,
                isAudio: false,
            };
        }

        if (url.match(/\.(mp4|webm)(\?|$)/i)) {
            return {
                embed: `<video controls autoplay><source src="${url}"></video>`,
                isAudio: false,
            };
        }

        if (url.match(/\.(mp3|wav|ogg|aac)(\?|$)/i)) {
            return {
                embed: `<audio controls autoplay><source src="${url}"></audio>`,
                isAudio: true,
            };
        }

        // Fallback: generic iframe
        return {
            embed: `<iframe src="${url}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`,
            isAudio: false,
        };
    },

    getYoutubeId(url) {
        const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        return match ? match[1] : null;
    },

    getVimeoId(url) {
        const match = url.match(/vimeo\.com\/(\d+)/);
        return match ? match[1] : null;
    },
};

export default VideoModal;
